var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainCard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3H2V13H1V3ZM3 2H4V14H3V2ZM7 11H13V12H7V11ZM7 8H13V9H7V8Z",
    fill: "#E78C40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.85 4.65L11.35 1.15C11.25 1.05 11.15 1 11 1H6C5.45 1 5 1.45 5 2V14C5 14.55 5.45 15 6 15H14C14.55 15 15 14.55 15 14V5C15 4.85 14.95 4.75 14.85 4.65ZM11 2.2L13.8 5H11V2.2ZM14 14H6V2H10V5C10 5.55 10.45 6 11 6H14V14Z",
    fill: "#E78C40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainCard1);
export default __webpack_public_path__ + "static/media/mainCard1.9c123bdb15edc6521955798120523ff0.svg";
export { ForwardRef as ReactComponent };